import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import LoadingSpinner from '../common/LoadingSpinner';

/**
 * AuthGuardian ensures that authenticated state is properly maintained during navigation
 * It acts as a wrapper for other components to ensure auth state is consistent before rendering
 */
const AuthGuardian = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log('AuthGuardian: Checking authentication for path:', location.pathname);
    
    // Do a direct localStorage check
    const token = localStorage.getItem('token');
    const userJson = localStorage.getItem('user');
    
    console.log('AuthGuardian: token exists =', !!token);
    console.log('AuthGuardian: user exists =', !!userJson);
    
    if (!token) {
      console.log('AuthGuardian: No token found, redirecting to login');
      // No token - redirect to login
      navigate('/auth/login', { replace: true, state: { from: location } });
      return;
    }
    
    // Verify the user data if it exists
    if (userJson) {
      try {
        const userData = JSON.parse(userJson);
        console.log('AuthGuardian: User data parsed successfully', userData.role);
        
        // Basic validation of user data
        if (!userData || (!userData.id && !userData._id) || !userData.role) {
          console.log('AuthGuardian: User data is invalid');
          // Token exists but user data is invalid - still consider authenticated
          // but clear the invalid user data
          localStorage.removeItem('user');
        }
      } catch (error) {
        console.error('AuthGuardian: Error parsing user data', error);
        // Invalid user JSON - remove it
        localStorage.removeItem('user');
      }
    }
    
    // If we get here, we have at least a token, so we're authenticated
    setIsAuthenticated(true);
    setLoading(false);
  }, [location.pathname, navigate]);

  if (loading) {
    return (
      <div className="flex flex-col justify-center items-center min-h-screen">
        <div className="mb-4">Validating authentication...</div>
        <LoadingSpinner />
      </div>
    );
  }

  // If authenticated, render the children
  return children;
};

export default AuthGuardian;